import PageContainer from '@/common/components/PageContainer'
import WithdrawListing from '@/modules/transaction/components/WithdrawListing'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import useQueryWithdrawTransaction from '@/modules/transaction/api/hooks/useQueryWithdrawTransaction'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { parseAsArrayOf, parseAsStringEnum, useQueryState } from 'nuqs'
import {
	TransactionProcessor,
	WithdrawStatus,
	SortOrder,
	PlayerBankType,
} from '@/schema'
import { useState } from 'react'
import { useDateFilter } from '@/common/hooks/useDateFilter'

function WithdrawPage() {
	const { pageSize, currentPage, searchQuery } = useTablePagination()
	const [processBy] = useQueryState<TransactionProcessor>(
		'processBy',
		parseAsStringEnum(Object.values(TransactionProcessor)),
	)
	const [status] = useQueryState<WithdrawStatus[]>(
		'status',
		parseAsArrayOf(parseAsStringEnum(Object.values(WithdrawStatus))),
	)
	const [paymentGatewayId] = useQueryState('paymentGatewayId')
	const [playerBankType] = useQueryState<PlayerBankType>(
		'playerBankType',
		parseAsStringEnum(Object.values(PlayerBankType)),
	)

	const [amountSort, setAmountSort] = useState<SortOrder | undefined>(undefined)
	const [createdAtSort, setCreatedAtSort] = useState<SortOrder | undefined>(
		SortOrder.desc,
	)
	const { dateFilter } = useDateFilter()

	const handleSort = (columnId: string, order: SortOrder | undefined) => {
		if (columnId === 'amount') {
			setAmountSort(order)
			setCreatedAtSort(undefined)
		} else if (columnId === 'createdAt') {
			setCreatedAtSort(order)
			setAmountSort(undefined)
		}
	}

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		search: searchQuery,
		paymentGatewayId: paymentGatewayId || undefined,
		processor: processBy || undefined,
		status: status && status.length > 0 ? status : undefined,
		playerBankType: playerBankType || undefined,
		sortByCreatedAt: createdAtSort as SortOrder,
		sortByAmount: amountSort ? (amountSort as SortOrder) : undefined,
		startDate: dateFilter.startDate || undefined,
		endDate: dateFilter.endDate || undefined,
	}

	const { data, refetch, isLoading } = useQueryWithdrawTransaction(payload)

	const withdrawList = data?.data || []
	const totalWithdraws = data?.total || 0

	return (
		<PageContainer>
			<div className="flex-1 space-y-4">
				<WithdrawListing
					data={withdrawList}
					total={totalWithdraws}
					onRefresh={refetch}
					isLoading={isLoading}
					onSort={handleSort}
				/>
			</div>
		</PageContainer>
	)
}

const GuardedWithdrawPage = withUserPermission(WithdrawPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_BANK_TRANSACTION],
})

export default GuardedWithdrawPage
